import {
  identify,
  SKIP_TITLE_CASE,
  track as analyticsTrack,
} from '@nexus/fff-analytics';
import toString from 'lodash/toString';

export const btnLocationEnum = {
  productCard: 'Product Card',
  productAccordion: 'Product Accordion',
  cart: 'Cart',
  learnMore: 'Learn More',
  search: 'Flash Sale Search',
  friendWidget: 'Friend Widget',
  preSalePage: 'Pre-Sale Page',
  saleBanner: 'Sale Banner',
  floatingCTA: 'Floating CTA',
  friendsCart: 'Friends Cart',
  featuredCarousel: 'Featured Carousel',
  pinnedProduct: 'Pinned Product',
  recommendedCard: 'Recommended Product Card',
  recommendedAccordion: 'Recommended Product Accordion',
  introProduct: 'Intro Product',
  boxSubscription: 'Box Subscription',
};

export const productAvailabilityEnum = {
  outOfStock: 'OOS',
  inStock: 'In Stock',
};

export const segmentEnum = {
  productViewed: 'Product Viewed',
  productAdded: 'Product Added',
  productRemoved: 'Product Removed',
  productFavorited: 'Product Favorited',
  productUnfavorited: 'Product Unfavorited',
  clickedElement: 'Clicked Element',
  searchStarted: 'Search Started',
  searchCompleted: 'Search Completed',
  FBProductAdded: 'FB Product Added',
  inviteSent: 'Invite Sent',
  experimentViewed: 'Experiment Viewed',
  carouselSwiped: 'Carousel Swiped',
  reactivateStarted: 'Reactivation Started',
  upgradeStarted: 'Upgrade Started',
  acquisitionStarted: 'Acquisition Started',
};

export const EXPERIENCES = {
  addOns: 'add-ons',
  edit: 'edit',
  pdp: 'PDP',
};

export const REACTIVATE_TRACKING_DATA = {
  expiredType: 'Expired Member',
  canceledType: 'Canceled Member',
  expiredReactivationType: 'Expired',
  canceledReactivationType: 'Canceled',
};

const ANONYMOUS_ID_LOCAL_STORAGE_KEY = 'ajs_anonymous_id';

export const getAnonymousId = () => {
  const anonymousIdFromLocalStorage =
    localStorage?.getItem(ANONYMOUS_ID_LOCAL_STORAGE_KEY) || null;

  return JSON.parse(anonymousIdFromLocalStorage) || '';
};

/*
 * catching any errors in the imported track method call
 * and logging them because they should never affect ui
 */
export function track(trackName, trackingData) {
  try {
    const optimizelyOptions = {
      Optimizely: { userId: toString(trackingData.user_id) },
    };
    analyticsTrack({
      trackName,
      properties: trackingData,
      options: optimizelyOptions,
    });
  } catch (e) {
    console.error(e);
  }
}

export function trackOptimizelyExperiment(
  decisionData,
  userId,
  campaignId,
  planCode
) {
  const { experimentName, variationName, featureFlagName, experimentRunning } =
    decisionData;
  if (experimentRunning) {
    if (window.analytics.user) window.analytics.user().traits({});
    track(segmentEnum.experimentViewed, {
      experiment_name: experimentName,
      variation_name: variationName,
      feature_flag_name: featureFlagName,
      campaign_id: campaignId,
      plan_code: planCode,
    });
    // traits needs props in camel case
    identify({
      userId,
      traits: {
        experimentName,
        variationName,
        featureFlagName,
        campaignId,
        planCode,
      },
      options: {
        Optimizely: {
          userId: userId && userId.toString(),
        },
      },
    });
  }
}

export const trackUpgradeStarted = ({ cta, experience }) =>
  analyticsTrack({
    trackName: segmentEnum.upgradeStarted,
    properties: {
      cta_name: cta,
      experience,
    },
  });

export const trackReactivateStarted = ({
  cta,
  type,
  experience,
  reactivationType,
}) =>
  analyticsTrack({
    trackName: segmentEnum.reactivateStarted,
    properties: {
      cta_name: cta,
      type,
      experience,
      reactivation_type: reactivationType,
    },
  });

export const trackClickCheckoutPDP = (cta) =>
  analyticsTrack({
    trackName: segmentEnum.productAdded,
    properties: {
      cta_name: cta,
      experience: EXPERIENCES.pdp,
    },
  });

export const trackAcquisitionStarted = ({
  cta,
  sku,
  productName,
  salePrice,
  acquisitionType,
  userId,
  type,
}) => {
  const skuFormatted = sku && sku.toUpperCase();
  return analyticsTrack({
    trackName: segmentEnum.acquisitionStarted,
    properties: {
      cta_name: cta,
      acquisition_type: acquisitionType,
      sku: skuFormatted,
      product_name: productName,
      sale_price: salePrice,
      [SKIP_TITLE_CASE]: ['sku'],
      user_id: typeof userId === 'string' ? userId : toString(userId),
      type,
    },
  });
};
